export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7216.2da1aca5.jpg";